<template>
    <div class="hstack gap-1 h-100">
        <slot name="label">{{ label }}</slot>
        <Multiselect
            ref="select"
            :model-value="modelValue"
            :options="items"
            mode="single"
            :close-on-select="true"
            :label="'text'"
            :searchable="true"
            :filter-results="true"
            :strict="false"
            :submit="false"
            :native-support="true"
            :classes="{
                tag: 'bg-secondary text-white text-sm py-0.5 pl-2 rounded mr-1 mb-1 flex items-center tagwidth-100 text-truncate rtl:pl-0 rtl:pr-2 rtl:mr-0 rtl:ml-1',
            }"
            @update:model-value="handleUpdate($event)">
        </Multiselect>
    </div>
</template>
<script setup lang="ts">
import Vue from "vue";
import {defineComponent, ref, watch} from "vue";
import type {PropType} from "vue";
import Multiselect from "@vueform/multiselect";
import {BFieldSelection} from "../BFilterEditor/BFilterEditor.types";

var select = ref<any | null>(null);

const props = defineProps<{
    items: BFieldSelection[];
    disabled: boolean;
    modelValue: string;
    label: string;
}>();

const emit = defineEmits<{
    (event: "update:modelValue", value: string): void;
}>();

function handleUpdate(event: any) {
    if (select.value != null) {
        select.value.focus();
    }
    emit("update:modelValue", event);
}
</script>
